import * as React from "react"
import type { SVGProps } from "react"
const SvgFolders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 21.71q-.83 0-1.41-.58A2 2 0 0 1 1 19.7v-12q0-.42.29-.7A1 1 0 0 1 2 6.7q.42 0 .71.3.3.27.29.7v12h16q.42 0 .71.3.3.28.29.7 0 .43-.29.72a1 1 0 0 1-.71.28zm4-4q-.82 0-1.41-.58A2 2 0 0 1 5 15.7v-11q0-.83.59-1.4A2 2 0 0 1 7 2.7h4.18a2 2 0 0 1 1.4.58L14 4.7h7q.83 0 1.41.6.6.57.59 1.4v9q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h14v-9h-7.82l-2-2H7z" />
  </svg>
)
export default SvgFolders
